import React from "react";
import { t } from "i18next";
import { Col, Row } from "reactstrap";
import { useParams, useHistory } from "react-router-dom";
import StudentStats from "./StudentStats";
import AssessmentProgressBanner from "./AssessmentProgressBanner";
import { formatRecommendationAction } from "../../utils/formatRecommendationAction";

const StudentInfo = ({
  data,
  levels = [],
  sessions = [],
  summary = null,
  session = null,
  onCreateAssessment = null,
}) => {
  const params = useParams();
  const history = useHistory();

  const rawCurrentLevel = summary?.studentLevels?.current;
  const suggestedAction = formatRecommendationAction(
    summary?.recommendation,
    levels,
  );

  const getSessionId = (sessionValue) =>
    typeof sessionValue === "string"
      ? sessionValue
      : (sessionValue?.id ?? sessionValue?._id);

  const activeSessionId = getSessionId(session) ?? getSessionId(sessions[0]);

  const navigateToAssessment = (step) => {
    if (!activeSessionId) return;

    const basePath = params.school
      ? `/schools/${params.school}/classrooms/${params.classroom}`
      : `/classrooms/${params.classroom}`;
    const assessmentPath = `${basePath}/sections/${params.section}/students/${params.student}/sessions/${activeSessionId}/evaluate`;

    history.push(
      step
        ? `${assessmentPath}?step=${encodeURIComponent(step)}`
        : assessmentPath,
    );
  };

  const handleStartAssessment = () => navigateToAssessment();

  const handleCompleteDecision = () =>
    navigateToAssessment("assessment-results");

  const handleCreateAssessment = () => {
    if (onCreateAssessment) {
      onCreateAssessment();
    }
  };

  const stats = [
    {
      title: t("profile.totalAssessments"),
      value: data.numberOfAssessments || 0,
      iconType: "users",
      badgeBg: "#E6F7F5",
      iconColor: "#0D9488",
    },
    {
      title: t("profile.latestAssessments"),
      value: data.lastAssessmentDate || "-",
      iconType: "calendar",
      badgeBg: "#E6F7F5",
      iconColor: "#0D9488",
    },
    {
      title: t("profile.suggestedAction"),
      value: suggestedAction,
      iconType: "bulb",
      badgeBg: "#FFF3EB",
      iconColor: "#F97316",
    },
    {
      title: t("profile.currentLevel"),
      value: rawCurrentLevel?.code ?? "-",
      iconType: "chart",
      badgeBg: "#E6F7F5",
      iconColor: "#0D9488",
    },
  ];

  return (
    <div className="pt-2 mb-4 profile-card-block-new">
      <Row className="mb-4 text-end">
        <Col>
          <div className="student-name-container p-0">
            <h2 className="student-name">{data.studentName}</h2>
            <div className="student-subinfo">
              {data.className} | {data.sectionName}
            </div>
          </div>
        </Col>
      </Row>

      <AssessmentProgressBanner
        summary={summary}
        onStartAssessment={handleStartAssessment}
        onCompleteDecision={handleCompleteDecision}
        onCreateAssessment={handleCreateAssessment}
      />

      <Row className="g-3">
        {stats.map((item, index) => (
          <StudentStats
            key={index}
            title={item.title}
            value={item.value}
            iconType={item.iconType}
            badgeBg={item.badgeBg}
            iconColor={item.iconColor}
          />
        ))}
      </Row>
    </div>
  );
};

export default StudentInfo;
